<template>
  <div class="moregb-bck" v-if="moreGroup && moreGroup.length">
    <div class="content">
     <!-- <i class="fa fa-icon_home_clear" @click="close"></i> -->
     <img class="icon_close" src="@/assets/img/icon/close.svg" @click="close" alt="">
        <ul>
            <li>
                <ul class="spell-group" v-for="(item, index) in moreGroup" :key="index">
                    <li v-if="item.member_info">
                        <img :src="item.member_info[0].avatar" alt="">
                    </li>
                    <li v-if="item.member_info" class="controltext">
                        {{item.member_info[0].name}}
                    </li>
                    <li>
                        还差{{item.group_num - item.member_info.length}}人拼团成功
                    </li>
                    <li>
                        <Countdown v-if="item.create_at" :callback="callback" :item="item" :endTime="item.duration*60*60 + item.create_at" endText="活动已经结束" :textState="0" :type="2"></Countdown>
                    </li>
                    <li @click="Cjoin(item.group_id), getJoinPrice(item.price)">
                        去参团
                    </li>
                </ul>
            </li>
        </ul>
    </div>
  </div>
</template>
<script>
import Countdown from '@/components/CountDown'
export default {
  props: ['moreGroup'],
  data () {
    return {
    }
  },
  components: {
    Countdown
  },
  methods: {
    close () {
      this.$store.commit('change')
    },
    getJoinPrice (e) {
      this.$store.commit('getjoinprice', e)
    },
    Cjoin (e) {
      this.$emit('moreJoin', 'join', e)
    },
    callback (item) {
      this.moreGroup.splice(this.moreGroup.indexOf(item), 1)
    }
  },
  created () {
    // console.log('弹框', this.moreGroup)
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/_base.scss";
.moregb-bck{
    // display: none;
    position: fixed;
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.3);
    z-index: 2000;
    left: 0;
    top: 0;
    .content{
    position: relative;
    width: 601px;
    background: white;
    box-shadow:0px 0px 16px 0px rgba(127,130,137,0.6);
    border-radius:8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50% ,-50%);
    padding: 48px 40px;
    box-sizing: border-box;
    .icon_close{
    width: 30px;
    height: 30px;
    position: absolute;
    top: -14px;
    right: -13px;
    font-size: 30px;
    opacity: 0.7;
    cursor: pointer;
    }
    ul{
      li{
        list-style: none;
      }
    }
    .spell-group{
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      li{
        line-height: 32px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
      }
      li:nth-child(1){
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: cadetblue;
        img{
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }
      }
      li:nth-child(2){
        color:rgba(44,45,46,1);
      }
      li:nth-child(3){
        color:rgba(47,48,49,1);
      }
      li:nth-child(4){
        color:rgba(44,45,46,0.78);
      }
      li:nth-child(5){
        background:linear-gradient(90deg,rgba(248,90,74,1) 0%,rgba(255,118,104,1) 100%);
        border-radius:4px;
        color: white;
        width: 81px;
        height: 30px;
        text-align: center;
        cursor: pointer;
      }
      .controltext{
        width: 67px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .countdown{
        width: 84px;
      }
    }
    }
}
// 平板适配
@media (min-width: 768px) and (max-width: 1372px) {
  .moregb-bck{
    .content{
      top: 35%;
      transform: translate(-50% ,-35%);
    }
  }
}
</style>
